var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-skeleton-loading"},[_c('van-loading',{attrs:{"tsize":"24px","vertical":""}}),_vm._v(" 加载中... "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }